module.exports = __webpack_public_path__ + "img/flag_2.abcc1df7.png";